import NextHead from "next/head";
import React from "react";

const Head: React.FC = () => (
  <NextHead>
    <meta name="robots" content="noindex, nofollow" />
  </NextHead>
);

export { Head };
